module.exports = __webpack_public_path__ + "static/media/truck-container.70feb763.svg";